import type { App } from 'vue';
import baseFr from "@nextories/vue-tasks/src/i18n/langs/fr/index";
import datetimeFormats from "@nextories/vue-tasks/src/i18n/datetimeFormats";
import numberFormats from "@nextories/vue-tasks/src/i18n/numberFormats";
import { createI18n } from "vue-i18n";
import fr from "@/i18n/langs/fr/index";

export const i18n = createI18n({
  legacy: false,
  fallbackLocale: "fr",
  warnHtmlMessage: false,
  locale: "fr",
  allowComposition: true,
  datetimeFormats,
  numberFormats,
  messages: {
    fr: {
      ...baseFr,
      ...fr,
    },
  },
});

export const i18nPlugin = {
  install: (app: App) => {
    app.use(i18n);
  },
};

export default i18nPlugin;
